<template>
  <v-navigation-drawer
    :value="isOpen"
    :permanent="smAndUp && isOpen"
    :temporary="smOnly && isOpen"
    :overlay-opacity="0"
    class="elevation-0"
    style="padding-top: 30px; border-right: 1px solid #353537 !important"
    color="neutral800"
    :width="$attrs.width || 232"
    floating
    app
    @input="(v) => $store.commit('app/setIsDrawerOpen', v)"
  >
    <a style="width: 255px" @click="$router.push('/exhibitions')">
      <SizeBox width="14" />
      <v-img
        :src="require(`@/assets/icons/logo.svg`)"
        width="157"
        style="margin-left: 22px; background-size: 100%"
      ></v-img>
    </a>
    <SizeBox height="30" />
    <v-card
      v-if="!variant && false"
      flat
      color="transparent"
      class="d-flex align-center"
    >
      <div class="pa-4">
        <v-img src width="150" />
      </div>
      <v-btn
        color="Secondary900"
        small
        text
        fab
        @click="$store.commit('app/setIsDrawerOpen', false)"
      >
        <v-icon>mdi-backburger</v-icon>
      </v-btn>
    </v-card>

    <div class="w100p d-flex justify-end">
      <nav-items :navs="navs" :variant="variant" root></nav-items>
    </div>

    <div class="bot_logo w100p flex-center">
      <SizeBox width="24" />
      <NavUserInfo v-on="$listeners" />
      <!-- <div class="pos-r w90p text-center">
        <span class="text-caption">虛擬展場技術由 黑洞創造 提供</span>
        <SizeBox height="16" />
        <v-img
          :src="require(`@/assets/icons/BKHole.svg`)"
          width="55%"
          class="mx-auto"
          contain
        ></v-img>
        <SizeBox height="44" />
      </div> -->
      <SizeBox width="24" />
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';

import navItems from './navItems.vue';
import NavUserInfo from '@/components/NavUserInfo';
import { routes } from '@/router/routes';

export default {
  components: { navItems, NavUserInfo },
  computed: {
    ...mapGetters({ isOpen: 'app/getIsDrawerOpen' }),
    navs() {
      let route = routes();
      return route;
    },
    mdAndUp() {
      return this.$vuetify.breakpoint && this.$vuetify.breakpoint.mdAndUp;
    },
    smAndUp() {
      return this.$vuetify.breakpoint && this.$vuetify.breakpoint.smAndUp;
    },
    smAndDown() {
      return this.$vuetify.breakpoint && this.$vuetify.breakpoint.smAndDown;
    },
    smOnly() {
      return this.$vuetify.breakpoint && this.$vuetify.breakpoint.smOnly;
    },

    variant() {
      return !this.isOpen;
    }
  }
};
</script>

<style lang="scss" scoped>
.bot_logo {
  position: absolute;
  width: 100%;
  bottom: 35px;
  left: 0;
}
::v-deep {
  .v-image__image {
    background-size: 100%;
  }
}
</style>
